export type { ProjectSnapshot, SnapshotDependency } from "../models/Snapshot.js";

export const SNAPSHOT_DIR = ".kyro/snapshots";
export const SNAPSHOT_INDEX = ".kyro/snapshots/index.json";
